module.exports = __webpack_public_path__ + "img/bg.9f7ef0e2.png";